type ValidateEntityOnCustomFormParams = {
  entity: string[]
  isRequired?: boolean
}

export default function validateEntityOnCustomForm({ entity, isRequired }: ValidateEntityOnCustomFormParams) {
  let error = ''

  if (isRequired && entity.length === 0) {
    error = 'Este campo é obrigatório'
  }
  return error
}
